import type { PivotDateGroupEnum } from '@ztechapps/common.contract'
import type { PivotField } from '@ztechapps/common.contract'
import { PivotFieldTypeEnum } from '@ztechapps/common.contract'
import { toPivotDatePartLabel } from './toPivotDatePartLabel'

/** Label of a layout field — a date field reads as its part, any other field as its name. */
export const toPivotFieldLabel = (
  pivotField: PivotField | undefined,
  field: string,
  dateGroup?: PivotDateGroupEnum
): string => (pivotField?.type === PivotFieldTypeEnum.Date ? toPivotDatePartLabel(field, dateGroup) : field)
